// Resolve qual sub-grupo deve abrir automaticamente para o pathname atual.
// Considera match exato e prefixo (href + "/"), e escolhe o href de maior
// comprimento — o match mais específico. Retorna a key do grupo, ou null.
export interface ActiveGroupCandidate {
  key: string;
  hrefs: string[];
}

export function findActiveGroupKey(
  pathname: string,
  groups: ActiveGroupCandidate[],
): string | null {
  let bestLen = -1;
  let bestKey: string | null = null;

  for (const group of groups) {
    for (const href of group.hrefs) {
      const isMatch = pathname === href || pathname.startsWith(href + "/");
      // Empate de comprimento resolve por ordem de declaração (só ocorreria
      // em má-configuração de hrefs).
      if (isMatch && href.length > bestLen) {
        bestLen = href.length;
        bestKey = group.key;
      }
    }
  }

  return bestKey;
}
